import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { VehicleOverviewModel } from './../models/vehicle-overview.model';
import { Component, OnInit, OnChanges, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'wego-filter-vehicle-overview',
  template: require('../views/filter-vehicle-overview.component.html'),
  styles: [`
          .box-body{
            padding: 0px 10px;
          }
          `
  ]
})
export class FilterVehicleOverviewComponent implements OnInit, OnChanges {
  @Output('OnUpdateVehicleOverView') onUpdateVehicleOverView = new EventEmitter();
  @Input('VehicleOverviewList') vehicleOverviewList: VehicleOverviewModel[];
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  private filterVehicleOverviewList: VehicleOverviewModel[];

  brandList: string[];
  typeList: string[];
  fuleTypeList: string[];
  bodyStyleList: string[];
  priceingCategoryList: string[];
  additionalAttribute: string[] = [];

  selBrandList: string[] = [];
  selTypeList: string[] = [];
  selFuleTypeList: string[] = [];
  selBodyStyleList: string[] = [];
  selPriceingCategoryList: string[] = [];
  seladditionalAttribute: string[] = [];
  // selAirco: boolean = false;
  // selTowbar: boolean = false;

  constructor() { }

  ngOnChanges(change: any) {
    console.log(change);
    this.UpdateFilter();
  }

  ngOnInit() {
  }

  private UpdateFilter() {
    this.filterVehicleOverviewList = this.vehicleOverviewList;
    this.BrandFilter();
    this.TypeFilter();
    this.FuleFilter();
    this.BodyStyleFilter();
    this.PriceingCategoryFilter();
    this.AdditionalAttributeFilter();
    this.UpdateVehicleOverView();
  }

  private AdditionalAttributeFilter() {
    // let additionalAttribute = this.vehicleOverviewList.filter(x => this.HasValue(x.attributeList) && x.attributeList.length > 0).map(x => x.attributeList.map((y: any) => y.attributeName)).sort();
    // additionalAttribute.forEach(element => {
    //   element.forEach((element: any) => {
    //     this.additionalAttribute.push(element);
    //   });
    // });
    // this.additionalAttribute = this.JQueryHelper.Unique(this.additionalAttribute);

    let additionalAttribute = this.vehicleOverviewList.filter(x => this.HasValue(x.attributeList) && x.attributeList.length > 0).map(x => x.attributeList).sort();

    let place: any = [];
    additionalAttribute.forEach(element => {
      element.forEach((element: any) => {
        place.push(element);
      });
    });

    let flags = {};
    this.additionalAttribute = place.filter((entry: any) => {
      if (flags[entry.attributeName]) {
        return false;
      }
      flags[entry.attributeName] = true;
      return true;
    });

    console.log(this.additionalAttribute);
  }

  private BrandFilter() {
    let brand = this.vehicleOverviewList.filter(x => this.HasValue(x.brand)).map(x => x.brand).sort();
    this.brandList = this.JQueryHelper.Unique(brand);
  }

  private TypeFilter() {
    let type = this.vehicleOverviewList.filter(x => this.HasValue(x.type)).map(x => x.type).sort();
    this.typeList = this.JQueryHelper.Unique(type);
  }

  private FuleFilter() {
    let fuelType = this.vehicleOverviewList.filter(x => this.HasValue(x.fuelType)).map(x => x.fuelType).sort();
    this.fuleTypeList = this.JQueryHelper.Unique(fuelType);
  }

  private BodyStyleFilter() {
    let bodyStyle = this.vehicleOverviewList.filter(x => this.HasValue(x.bodyStyle)).map(x => x.bodyStyle).sort();
    this.bodyStyleList = this.JQueryHelper.Unique(bodyStyle);
  }

  private PriceingCategoryFilter() {
    let pricingCategory = this.vehicleOverviewList.filter(x => this.HasValue(x.pricingCategory)).map(x => x.pricingCategory).sort();
    this.priceingCategoryList = this.JQueryHelper.Unique(pricingCategory);
  }

  private HasValue(input: any) {
    if (input)
      return true;
    else
      return false;
  }

  private OnFilter(filterName: any, item: any, isChekced: any) {
    if (filterName == 'brand') {
      if (isChekced) {
        if (!(this.selBrandList.indexOf(item) > -1)) {
          this.selBrandList.push(item);
        }
      }
      else {
        this.selBrandList = this.JQueryHelper.RemoveFromArray(this.selBrandList, item);
      }
    }
    else if (filterName == 'type') {
      if (isChekced) {
        if (!(this.selTypeList.indexOf(item) > -1)) {
          this.selTypeList.push(item);
        }
      }
      else {
        this.selTypeList = this.JQueryHelper.RemoveFromArray(this.selTypeList, item);
      }
    }
    else if (filterName == 'fuletype') {
      if (isChekced) {
        if (!(this.selFuleTypeList.indexOf(item) > -1)) {
          this.selFuleTypeList.push(item);
        }
      }
      else {
        this.selFuleTypeList = this.JQueryHelper.RemoveFromArray(this.selFuleTypeList, item);
      }
    }
    else if (filterName == 'bodystyle') {
      if (isChekced) {
        if (!(this.selBodyStyleList.indexOf(item) > -1)) {
          this.selBodyStyleList.push(item);
        }
      }
      else {
        this.selBodyStyleList = this.JQueryHelper.RemoveFromArray(this.selBodyStyleList, item);
      }
    }
    else if (filterName == 'pricingcategory') {
      if (isChekced) {
        if (!(this.selPriceingCategoryList.indexOf(item) > -1)) {
          this.selPriceingCategoryList.push(item);
        }
      }
      else {
        this.selPriceingCategoryList = this.JQueryHelper.RemoveFromArray(this.selPriceingCategoryList, item);
      }
    }
    else if (filterName == 'additionalAttribute') {
      if (isChekced) {
        if (!(this.seladditionalAttribute.indexOf(item) > -1)) {
          this.seladditionalAttribute.push(item);
        }
      }
      else {
        this.seladditionalAttribute = this.JQueryHelper.RemoveFromArray(this.seladditionalAttribute, item);
      }
    }


    this.UpdateVehicleOverView();
  }

  private UpdateVehicleOverView() {
    let localList = this.vehicleOverviewList;
    localList = localList.filter(x => this.selBrandList.length == 0
      || this.selBrandList.indexOf(x.brand) > -1)
       .filter(x => this.selTypeList.length == 0
      || this.selTypeList.indexOf(x.type) > -1)
      .filter(x => this.selFuleTypeList.length == 0
        || this.selFuleTypeList.indexOf(x.fuelType) > -1)
      .filter(x => this.selBodyStyleList.length == 0
        || this.selBodyStyleList.indexOf(x.bodyStyle) > -1)
      .filter(x => this.selPriceingCategoryList.length == 0
        || this.selPriceingCategoryList.indexOf(x.pricingCategory) > -1)
      .filter(x => this.seladditionalAttribute.length == 0
        || this.ArrayContainsArray(x.attributeList.map((y: any) => y.attributeName), this.seladditionalAttribute))
    // .filter(x => this.selAirco == false || x.airco == this.selAirco)
    // .filter(x => this.selTowbar == false || x.towbar == this.selTowbar)
    this.onUpdateVehicleOverView.emit({ FilterVehicleOverview: localList });
  }

  private OnSearch($event: any) {
  }

  private intersect(a: any, b: any) {
    var t: any;
    if (b.length > a.length) t = b, b = a, a = t; // indexOf to loop over shorter
    return a.filter(function (e: any) {
      if (b.indexOf(e) !== -1) return true;
    });
  }

  private ArrayContainsArray(superset: any, subset: any) {
    if (0 == subset.length) {
      return true;
    }
    let retVal: boolean = subset.every(function (value: any) {
      return (superset.indexOf(value) >= 0);
    });
    return retVal;
  }

  public GroupByCategory(vehicleAttributeList: any) {
    if (vehicleAttributeList) {
      let prop = 'vehicleAttributeCategoryName';
      return vehicleAttributeList.reduce(function (groups: any, item: any) {
        let val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        groups[val] = groups[val].sort((obj1: any, obj2: any) => {
          if (obj1.attributeName > obj2.attributeName) {
            return 1;
          }
          if (obj1.attributeName < obj2.attributeName) {
            return -1;
          }
          return 0;
        });
        return groups;
      }, {});
    } else {
      return {};
    }
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/filter-vehicle-overview.component.ts